// "What this hits": a body that lights up the muscles a day's lifts work (Kenny's pick A, 2026-11-02;
// realistic drawing added the same day). Colours follow the signed-in person (style.css), so Kenny's
// is orange and Cassidy's is sage. The body follows the sex in the viewed person's settings.
import { BODY_DRAWINGS } from '../lib/body-outline.js';
import { MUSCLE_NAMES, musclesForDay } from '../lib/exercise-muscles.js';

const FILL = {
  main: 'rgb(var(--brand))', help: 'rgb(var(--brand) / 0.45)',
  off: '#C7C7CC', other: '#E0E0E4', head: '#D8D8DC', hair: '#8E8E93', edge: '#E2E2E6',
};

// Our muscle names to the drawing's areas. Shoulders differ by side: front delts show from the
// front, rear delts from the back, so a bench day doesn't light up the back of the shoulder.
export const LIT_AREA = {
  front: {
    chest: 'chest', frontDelts: 'deltoids', triceps: 'triceps', biceps: 'biceps', forearms: 'forearm', traps: 'trapezius',
    abs: 'abs', obliques: 'obliques', quads: 'quadriceps', adductors: 'adductors', calves: 'calves',
  },
  back: {
    rearDelts: 'deltoids', triceps: 'triceps', forearms: 'forearm', upperBack: 'upper-back', traps: 'trapezius', lowerBack: 'lower-back',
    glutes: 'gluteal', hamstrings: 'hamstring', adductors: 'adductors', calves: 'calves',
  },
};
const NEVER_LIT = new Set(['head', 'hair', 'hands', 'feet', 'ankles', 'knees', 'neck', 'tibialis']);

function bodySvg(sex, side, main, help) {
  const d = BODY_DRAWINGS[sex][side];
  const areas = (list) => new Set(list.map((m) => LIT_AREA[side][m]).filter(Boolean));
  const lit = areas(main);
  const helping = areas(help);
  const fillFor = (area) => {
    if (area === 'hair') return FILL.hair;
    if (area === 'head') return FILL.head;
    if (NEVER_LIT.has(area)) return FILL.other;
    return lit.has(area) ? FILL.main : helping.has(area) ? FILL.help : FILL.off;
  };
  const shapes = d.parts.map(([area, paths]) => paths.map((p) => `<path d="${p}" style="fill:${fillFor(area)}"/>`).join('')).join('');
  return `<svg viewBox="${d.viewBox}" class="w-full h-auto block" aria-hidden="true"><path d="${d.outline}" fill="#fff" stroke="${FILL.edge}" stroke-width="3"/>${shapes}</svg>`;
}

function figure(sex, side, label, main, help) {
  return `<div class="min-w-0">${bodySvg(sex, side, main, help)}<div class="text-[13px] font-semibold text-inksoft text-center mt-1">${label}</div></div>`;
}

export function bodyCard(exercises, sex = 'male') {
  const { main, help } = musclesForDay(exercises);
  if (!main.length && !help.length) return '';
  const body = BODY_DRAWINGS[sex] ? sex : 'male';
  const names = (list) => list.map((m) => MUSCLE_NAMES[m]);
  const summary = `Main muscles: ${names(main).join(', ')}.${help.length ? ` Helping: ${names(help).join(', ')}.` : ''}`;
  return `<div class="grit-card p-4 mt-4" role="img" aria-label="Body diagram. ${summary}">
    <div class="grit-eyebrow">What this hits</div>
    <div class="grid grid-cols-2 gap-3 max-w-[300px] mx-auto mt-2">${figure(body, 'front', 'Front', main, help)}${figure(body, 'back', 'Back', main, help)}</div>
    <div class="flex flex-wrap gap-1.5 mt-3">
      ${names(main).map((n) => `<span class="grit-chip-accent">${n}</span>`).join('')}
      ${names(help).map((n) => `<span class="grit-chip bg-fill text-inksoft">${n}</span>`).join('')}
    </div>
    <div class="flex gap-4 text-[13px] text-inksoft mt-2">
      <span class="inline-flex items-center gap-1.5"><span class="w-2.5 h-2.5 rounded-full" style="background:${FILL.main}"></span>Main</span>
      ${help.length ? `<span class="inline-flex items-center gap-1.5"><span class="w-2.5 h-2.5 rounded-full" style="background:${FILL.help}"></span>Helping</span>` : ''}
    </div>
  </div>`;
}
